export function validateDescription(job_description) {
  if (!job_description) return "Please select qualifications";
  return "";
}
